import { render, staticRenderFns } from "./FormMintInitialAllocation.vue?vue&type=template&id=0a45fe89&"
import script from "./FormMintInitialAllocation.vue?vue&type=script&lang=js&"
export * from "./FormMintInitialAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports